"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLeaderboardsMembersList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns MasochistME leaderboards.
 *
 * ### Filter options
 *
 * - `patreonTier` - filters by member's Patreon status,
 * - `isMember` - filters by user's member status in the MasochistME curator.
 *
 * ### Sort options
 *
 * - `position` - sorts by member's position on leaderboards,
 * - `gamesTotal` - sorts by member's number of all completed games,
 * - `badgesTotal` - sorts by member's number of all collected badges,
 * - `gamePoints` - sorts by member's amount of poins for all games,
 * - `badgePoints` - sorts by member's amount of points for all badges.
 *
 * ## Usage
 *
 * ```ts
 * const leaderboards: Leaderboards[] = await sdk.getLeaderboardsMembersList({ });
 * const leaderboardsByBadges: Game[] = await sdk.getLeaderboardsMembersList({ sort: { badgePoints: 'asc' }});
 * ```
 *
 * @param params.filter - Filter to apply to leaderboards list.
 * @param params.sort - Fields to sort leaderboards by.
 * @param params.limit - How many leaderboard entries will get returned.
 */
const getLeaderboardsMembersList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { filter, sort, limit } = params;
    const url = `${BASE_URL}/leaderboards/members/list`;
    const leaderboardsResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = leaderboardsResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getLeaderboardsMembersList = getLeaderboardsMembersList;
